import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { TabPanel } from '../../../../Components/Tab/TabPanel'
import { TabHeaderStyle } from '../../../../Components/Tab/styles'
import { AcademyEventRows } from './AcademyEventRows'
import { AcademyContext } from '../../../../Context/AcademyContext/AcademyContext'
import { SelectorsRow } from './SelectorsRow'
import { logEvent } from '../../../../Utils'
import { Tab } from '../../../../Components/LazyComponents'

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export const AcademyEventsTabs: React.FC<React.PropsWithChildren<unknown>> = () => {
  let query = useQuery()
  const tabQuery = query.get('tab')
  const tab = tabQuery === 'girls' ? 2 : tabQuery === 'boys' ? 1 : 0
  const { handleFilterChange } = useContext(AcademyContext)!
  const [value, setValue] = React.useState(tab)
  const tabTypes = [
    { id: 0, label: 'All', value: 'all' },
    { id: 1, label: 'Boys', value: 'boys' },
    { id: 2, label: 'Girls', value: 'girls' },
  ]

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    handleFilterChange('participant', tabTypes[newValue].value)
      logEvent('academy_events_tab_change', {
        tab: tabTypes[newValue].value,
      })
    setValue(newValue)
  }

  const handleStateChange = (val: string) => {
    handleFilterChange('state', val)
    logEvent('academy_events_state_change', {
      state: val
    })
  }

  const handleMonthChange = (val: string) => {
    handleFilterChange('month', val)
    logEvent('academy_month_change', {
      tab: val,
    })
  }

  const handleTrainingChange = (val: string) => {
    handleFilterChange('training', val)
    logEvent('academy_training_change', {
      tab: val,
    })
  }

  return (
    <>
      <TabHeaderStyle
        tabColor="light"
        value={value}
        onChange={handleChange}
        aria-label="academy event tabs"
      >
        {tabTypes.map((tab) => (
          <Tab key={tab.id} label={tab.label} />
        ))}
      </TabHeaderStyle>
      {tabTypes.map((tab) => (
        <TabPanel key={tab.id} value={value} index={tab.id} minHeight={500}>
          <SelectorsRow onStateChange={handleStateChange} onMonthChange={handleMonthChange} onTrainingChange={handleTrainingChange} />
          <AcademyEventRows />
        </TabPanel>
      ))}
    </>
  )
}
